<template>
    <form-builder :url="url" :method="method" :fields="fields" :argsdata="args.formobjects" :success="onSuccess"></form-builder>
</template>

<script>
    import FormBuilder from '../../frontend/components/FormBuilder';
    export default {
        components: {
            FormBuilder
        },
        props: {
            args: null
        },
        methods: {
            onSuccess() {
                location.href = "/account#options";
            }
        },
        mounted() {
        },
        data() {
            return {
                url: '/players/' + this.args.formobjects.id,
                method: 'patch',
                fields: [
                    [{type: 'header3',  value: __('account.global_options')}],
                    [{type: 'select', name: 'roundsort', label: __('account.roundsort'), options: [{id:1, name:__('account.roundsort_option1')}, {id:2, name:__('account.roundsort_option2')}], noblank: true}],
                    [{type: 'header3',  value: __('account.keyboard_shortcuts'), description: __('account.keyboard_shortcuts_description')}],
                    [{type: 'keyboard', name: 'keyboard_nextplayer', label: __('account.keyboard_nextplayer')},
                    {type: 'keyboard', name: 'keyboard_clear', label: __('account.keyboard_clear')}],
                    [{type: 'keyboard', name: 'keyboard_rest', label: __('account.keyboard_rest')},
                    {type: 'keyboard', name: 'keyboard_check', label: __('account.keyboard_check')}],

                    [{type: 'keyboard', name: 'keyboard_quick1', label: __('account.quickbutton') + " 1 "},
                    {type: 'inputnumber', name: 'value_quick1', label: __('account.quickbutton') + " 1 " + __('account.value')}],
                    [{type: 'keyboard', name: 'keyboard_quick2', label: __('account.quickbutton') + " 2 "},
                    {type: 'inputnumber', name: 'value_quick2', label: __('account.quickbutton') + " 2 " + __('account.value')}],
                    [{type: 'keyboard', name: 'keyboard_quick3', label: __('account.quickbutton') + " 3 "},
                    {type: 'inputnumber', name: 'value_quick3', label: __('account.quickbutton') + " 3 " + __('account.value')}],
                    [{type: 'keyboard', name: 'keyboard_quick4', label: __('account.quickbutton') + " 4 "},
                    {type: 'inputnumber', name: 'value_quick4', label: __('account.quickbutton') + " 4 " + __('account.value')}],
                    [{type: 'keyboard', name: 'keyboard_quick5', label: __('account.quickbutton') + " 5 "},
                    {type: 'inputnumber', name: 'value_quick5', label: __('account.quickbutton') + " 5 " + __('account.value')}],

                    [{type: 'submit', name: __('account.save')}]
                ]
            }

        }
    }
</script>
